export default "__VITE_ASSET__CtDglDoj__"